import { memo as Memo, useCallback, useRef } from 'react';
import { TweenMax } from 'gsap';

//* Components
import Translate from '@components/global/Translate';
import ArrowLeftBtn from '@components/global/SvgComponents/ArrowLeftBtn';

//* Styles
import NextPreStepsStyle from './style';

const NextPreSteps = Memo((props) => {
	//! Refs
	let ref = useRef();

	const handleHover = useCallback((enter) => {
		if (enter) {
			TweenMax.to(ref.current, 0, {
				opacity: 1,
			});
		} else {
			TweenMax.to(ref.current, 0, {
				opacity: 0,
			});
		}
	}, []);

	return (
		<NextPreStepsStyle className={'actionBtn'}>
			<div
				ref={ref}
				className={'NextBtnDescription'}>
				<Translate val={`NextBtnText${props.stateActive + 1}`} />
			</div>

			<div className={`actionBtnItem preBtnWrap`}>
				{props.stateActive > 0 && (
					<div
						onClick={props.prevStepOnclick}
						onMouseEnter={() => handleHover(true)}
						onMouseLeave={() => handleHover(false)}>
						<div className={'svg'}>
							<ArrowLeftBtn animate />
						</div>
					</div>
				)}
			</div>

			<div className={`actionBtnItem nextBtnWrap`}>
				<div
					onClick={props.nextStepOnclick}
					onMouseEnter={() => handleHover(true)}
					onMouseLeave={() => handleHover(false)}>
					<div className={'svg'}>
						<ArrowLeftBtn animate />
					</div>
				</div>
			</div>
		</NextPreStepsStyle>
	);
});

export default NextPreSteps;
